<span 
    *ngIf="value"
    [title]="value.nome"
    class="sgt-representante-modalidade-comercial-badge badge"
    [ngStyle]="{
        'background-color': value.backgroundColor,
        'color': value.color,
        'border-width': '1px',
        'border-style': 'solid', 
        'border-color': value.color,            
        'font-size': styles.fontSize
    }">
    {{value.nome}}
</span>
